import React from "react";
import { Redirect, Route } from "react-router-dom";
import { LoggedUserRole } from "../Repository/BaseRepository";
import { User_Roles } from "../Utils/Utils";

export const UserRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (LoggedUserRole !== undefined) {
          const rolesArray = LoggedUserRole.split(",").map(r => r.trim().toLowerCase());
          console.log("rolesArray:", rolesArray);

          if (
            rolesArray.includes(User_Roles.Normal_User.trim().toLowerCase()) ||
            rolesArray.includes(User_Roles.Super_User.trim().toLowerCase()) ||
            rolesArray.includes("pr coordinator") || 
            rolesArray.includes("canada coordinator")||
            rolesArray.includes("us coordinator")||
            rolesArray.includes("expenses") ||
            rolesArray.includes("billing coordinator") ||
            rolesArray.includes("timeSheet coordinator") ||
            rolesArray.includes("tenninetynine coordinator") ||
            rolesArray.includes("timecardfollowup coordinator") ||
            rolesArray.includes("automated user")
          ) {
            return <Component {...props} />;
          }

          if (rolesArray.includes(User_Roles.Client_User.trim().toLowerCase())) {
            return <Redirect to="updatecredentialGrid" />;
          }

          return <div>You do not have access to this page</div>;
        } else {
          return <Redirect to="/" />;
        }
      }}
    />
  );
};


export const AdminRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (LoggedUserRole !== undefined) {
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Super_User.trim().toLowerCase()
          )
            return <Component {...props} />;

          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Normal_User.trim().toLowerCase()
          )
            return <Redirect to="/dashboard" />;
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Client_User.trim().toLowerCase()
          )
            return <Redirect to="updatecredentialGrid" />;
          else return <div>You do not have access to this page</div>;
        }
        else {
          return <Redirect to="/" />
        }
      }}
    />
  );
};
export const TimecardFollowupRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (LoggedUserRole !== undefined) {
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.TimecardFollowup_User.trim().toLowerCase()
          )
            return <Component {...props} />;
          else return <div>You do not have access to this page</div>;
        }
        else {
          return <Redirect to="/" />
        }
      }}
    />
  );
};
